import {getFeatureFlags} from '@chekin/core';
import {CustomIcon, IconNames} from '@guestapp/old-ui-kit';
import {getLucideIcon} from './icons';

type Props = {
  name: string;
  size?: number;
  color?: string;
  className?: string;
};

function GuidebookIcon({name, size = 24, color, className}: Props) {
  const isRedesignEnabled = getFeatureFlags('IT_4595_GUIDEBOOKS_REDESING');

  if (!isRedesignEnabled) {
    return (
      <CustomIcon
        name={name as IconNames}
        size={size}
        color={color}
        className={className}
      />
    );
  }

  const Icon = getLucideIcon(name);
  if (!Icon) return null;

  return <Icon size={size} color={color} className={className} />;
}

export {GuidebookIcon};
